import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { AUTH_TOKEN } from '../helper/constants';
import { deleteCookieItem, getCookieItem } from '../helper/cookies';
import { errorHandling } from '../helper/errorHandling';

/**
 * SERVICE ENDPOINT
 */
// const endpoint = `${process.env.PROMO_SERVICE_CONNECTION_URL}/graphql`;
const endpoint = `http://localhost:4005/graphql`;
const httpLink = createHttpLink({
  uri: endpoint,
});

/**
 * GQL CONTEXT
 */
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = getCookieItem(AUTH_TOKEN);

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError, response }) => {
  if (graphQLErrors) {
    for (const { message } of graphQLErrors) {
      try {
        errorHandling(message);
      } catch (error) {
        // Handle the error or log it
      }
    }
  }
  //
  if (networkError) {
    errorHandling(networkError);
  }

  // handle n/w errors
  if (networkError?.statusCode === 401 || networkError?.statusCode === 403) {
    deleteCookieItem(AUTH_TOKEN);
  }

  // logout if the below error, status code  or error message coming...
  if (response && response.errors) {
    for (const error of response.errors) {
      if (
        error?.extensions?.code === 'UNAUTHENTICATED' ||
        error?.extensions?.response?.statusCode === 401 ||
        error?.extensions?.response?.statusCode === 403 ||
        error?.extensions?.response?.message === 'invalid token' ||
        error?.extensions?.response?.message === 'jwt expired' ||
        error?.extensions?.response?.message === 'invalid signature' ||
        error?.extensions?.response?.message ===
          'We coudnt find any account in this email...'
      ) {
        deleteCookieItem(AUTH_TOKEN);
      }
    }
  }
});

const link = from([errorLink, authLink.concat(httpLink)]);

const PromoServiceApolloConnector = new ApolloClient({
  // ssrMode: true,
  link: link,
  cache: new InMemoryCache(),
});

export default PromoServiceApolloConnector;
